import { useRef } from "react";
import usePermitForm from "./usePermitForm";
import { CodeStatus, PermitType, SignatureType } from "../common/enums";
import {
    MaritimeEventFormState_default,
    MaritimeEventFormState_populateErrorMessages,
    MaritimeEventFormState_toRequest
} from "../types/forms/Permits/MaritimeEventFormState";
import { MaritimeEvent_toFormState } from "../types/permits/MaritimeEvent";
import { PermitFormProps } from "../types/forms/Permits/PermitFormProps";
import usePortControlPermitForm from "./usePortControlPermitForm";

function useMaritimeEventForm(props: PermitFormProps) {
    const baseFormManager = usePortControlPermitForm({
        ...props,
        defaultFormState: MaritimeEventFormState_default,
        permitType: PermitType.MaritimeEvent,
        populateErrorMessages: MaritimeEventFormState_populateErrorMessages,
        toFormState: MaritimeEvent_toFormState,
        toRequest: MaritimeEventFormState_toRequest,
        clearErrorMessages: formState => MaritimeEventFormState_populateErrorMessages(formState, {}),
    });

    return {
        ...baseFormManager,
    };
}

export default useMaritimeEventForm;
